import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class Example extends Component {
  render() {
      return(
	<div class="container white_background">

		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_A ">
			    <p class="Concepts_line2">&nbsp;<br />Example<br />&nbsp;</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief no-gutters">
					<p>If you join the study and download Daily24 on March 10th, your <font style={{fontWeight: 'bold'}}>POWER28</font> will last from the beginning of <font style={{color:"#EF4A81", fontWeight: 'bold'}}>March 10th</font> until the end of <font style={{color:"#EF4A81",  fontWeight: 'bold'}}>April 4th</font>.</p>
                    <p><font style={{fontWeight: "bold"}}>POWER Week 1</font> will be <font style={{color:"#3c5b89", fontWeight: "bold"}}>May 1 - May 7</font>
					<br /><font style={{fontWeight: "bold"}}>POWER Week 2</font> will be <font style={{color:"#3c5b89", fontWeight: "bold"}}>May 29 - June 4</font>
					<br /><font style={{fontWeight: "bold"}}>POWER Week 3</font> will be <font style={{color:"#3C5B89", fontWeight: "bold"}}>June 26 - July 2</font>
					<br /><font style={{fontWeight: "bold"}}>POWER Week 4</font> will be <font style={{color:"#3C5B89", fontWeight: "bold"}}>July 24 - July 30</font>
					<br /><font style={{fontWeight: "bold"}}>POWER Week 5</font> will be <font style={{color:"#3C5B89", fontWeight: "bold"}}>Aug 21 - Aug 27</font>.</p>
				</div>
				<div class="row">
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
						<img class="example_calendar_img" src="https://i.ibb.co/Q8Fyt24/slice63-3x.png" alt="slice63-3x" border="0"/>
					</div>
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
                        <img class="example_calendar_img" src="https://i.ibb.co/FBJbyKf/slice62-3x.png" alt="slice62-3x" border="0"/>
					</div>
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
						<img class="example_calendar_img" src="https://i.ibb.co/B3VCXfG/slice61-3x.png" alt="slice61-3x" border="0"/>
					</div>
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
						<img class="example_calendar_img" src="https://i.ibb.co/hddLhXd/slice58-3x.png" alt="slice58-3x" border="0"/>
					</div>
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
						<img class="example_calendar_img" src="https://i.ibb.co/jRSRq3w/slice57-3x.png" alt="slice57-3x" border="0"/>
					</div>
					<div class="col-6 col-sm-6 col-md-4 col-lg-5 col-xl-4">
						<img class="example_calendar_img" src="https://i.ibb.co/jHhBQrN/slice59-3x.png" alt="slice59-3x" border="0"/>
					</div>



				</div>

		<div>
			<p>&nbsp;</p>
			<p>&nbsp;</p>

	    </div>

	    <div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/leaderBoard">
				   <a href="#"  class="Bottom_button_r">
				   <p>What is the Leaderboard?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>


			</div>



		</div>




	</div>
          )
  }
}



// WEBPACK FOOTER //
// ./src/components/Example.js